import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "details"
}
const _hoisted_2 = { class: "max-mobile-width" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col col-auto text-end" }
const _hoisted_6 = { class: "mt-4 mb-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "card mb-4 p-4" }
const _hoisted_10 = { class: "card-header transport-card-header" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "pt-1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-primary" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "text-blue" }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "text-primary text-center" }
const _hoisted_20 = { class: "col col-auto" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  class: "modal fade",
  id: "wantSooner",
  tabindex: "-1",
  "aria-labelledby": "Want sooner",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "modal-dialog" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = { class: "modal-body" }
const _hoisted_26 = { class: "row mb-4" }
const _hoisted_27 = { class: "col col-auto" }
const _hoisted_28 = { class: "col text-center" }
const _hoisted_29 = { class: "col-form-label" }
const _hoisted_30 = { class: "col col-auto" }
const _hoisted_31 = { class: "row mb-4" }
const _hoisted_32 = { class: "col col-auto" }
const _hoisted_33 = { class: "col text-center" }
const _hoisted_34 = { class: "col-form-label" }
const _hoisted_35 = { class: "col col-auto" }
const _hoisted_36 = { class: "row mb-4" }
const _hoisted_37 = { class: "col col-auto" }
const _hoisted_38 = { class: "col text-center" }
const _hoisted_39 = { class: "col-form-label" }
const _hoisted_40 = { class: "col col-auto" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "row mb-4" }
const _hoisted_44 = { class: "col-sm-8" }
const _hoisted_45 = { class: "row mb-4" }
const _hoisted_46 = { class: "col-sm-8" }
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "row mb-4" }
const _hoisted_50 = { class: "col col-auto" }
const _hoisted_51 = { class: "col text-center" }
const _hoisted_52 = { class: "col-form-label" }
const _hoisted_53 = { class: "col col-auto" }
const _hoisted_54 = { class: "row mb-4" }
const _hoisted_55 = { class: "col col-auto" }
const _hoisted_56 = { class: "col text-center" }
const _hoisted_57 = { class: "col-form-label" }
const _hoisted_58 = { class: "col col-auto" }
const _hoisted_59 = { class: "row mb-4" }
const _hoisted_60 = { class: "col" }
const _hoisted_61 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_numerictextbox = _resolveComponent("numerictextbox")!

  return (_ctx.busCase)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: { name: 'home' },
                  class: "btn btn-secondary"
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createElementVNode("span", { class: "k-icon k-i-arrow-left" }, null, -1),
                    _createElementVNode("span", null, "Výpis přeprav", -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: { name: 'login', query: { logout: 1 } },
                  class: "btn btn-secondary"
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createElementVNode("span", { class: "k-icon k-i-logout" }, null, -1),
                    _createElementVNode("span", null, "Odhlásit", -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("h1", _hoisted_6, [
              (!_ctx.busCase.isLoaded)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Plánovaná nakládka"))
                : _createCommentVNode("", true),
              (_ctx.busCase.isLoaded)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Plánovaná vykládka"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_ctx.busCase.document), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", null, [
                      _cache[20] || (_cache[20] = _createTextVNode("Čas: ")),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatDateTime(_ctx.luTime)), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, [
                      _cache[21] || (_cache[21] = _createTextVNode("Místo: ")),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.luPlace), 1)
                    ])
                  ]),
                  (_ctx.luDelayTime)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _cache[22] || (_cache[22] = _createTextVNode(" Nahlášený nový čas dojezdu: ")),
                        _createElementVNode("strong", _hoisted_15, _toDisplayString(_ctx.luDelayTime), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.busCase.queueId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[23] || (_cache[23] = _createTextVNode(" Požadavek na dřívější čas od: ")),
                        _createElementVNode("strong", _hoisted_17, _toDisplayString(_ctx.queueSinceTime), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.busCase.queueOffered)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[26] || (_cache[26] = _createElementVNode("hr", null, null, -1)),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("p", null, [
                            _cache[24] || (_cache[24] = _createTextVNode(" Uvolnil se termín: ")),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.queueOfferedTime), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              type: "button",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.acceptTime()))
                            }, " Beru "),
                            _cache[25] || (_cache[25] = _createTextVNode("   ")),
                            _createElementVNode("button", {
                              class: "btn btn-secondary",
                              type: "button",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rejectTime()))
                            }, " Nechci ")
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.busCase.isKourim && !_ctx.busCase.queueId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _cache[39] || (_cache[39] = _createElementVNode("button", {
                          class: "btn btn-primary",
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#wantSooner"
                        }, " Mohu dřív ", -1)),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _cache[36] || (_cache[36] = _createElementVNode("button", {
                                  type: "button",
                                  class: "d-none",
                                  "data-bs-dismiss": "modal",
                                  "aria-label": "Close",
                                  id: "wantSoonerDismiss"
                                }, null, -1)),
                                _cache[37] || (_cache[37] = _createElementVNode("p", null, "Kdy můžete nejříve přistavit:", -1)),
                                _createElementVNode("div", _hoisted_26, [
                                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col col-auto min-width-date-time" }, [
                                    _createElementVNode("label", { class: "col-form-label" }, "Datum")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-secondary",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.minusSoonerDate()))
                                    }, _cache[27] || (_cache[27] = [
                                      _createElementVNode("i", { class: "k-icon k-i-minus" }, null, -1)
                                    ]))
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.soonerTimeDatePart), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-secondary",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.plusSoonerDate()))
                                    }, _cache[28] || (_cache[28] = [
                                      _createElementVNode("i", { class: "k-icon k-i-plus" }, null, -1)
                                    ]))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col col-auto min-width-date-time" }, [
                                    _createElementVNode("label", { class: "col-form-label" }, "Čas")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-secondary",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.minusSoonerTime()))
                                    }, _cache[30] || (_cache[30] = [
                                      _createElementVNode("i", { class: "k-icon k-i-minus" }, null, -1)
                                    ]))
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.soonerTimeTimePart), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-secondary",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.plusSoonerTime()))
                                    }, _cache[31] || (_cache[31] = [
                                      _createElementVNode("i", { class: "k-icon k-i-plus" }, null, -1)
                                    ]))
                                  ])
                                ]),
                                _cache[38] || (_cache[38] = _createElementVNode("p", null, "Kolik času potřebujete na přistavení:", -1)),
                                _createElementVNode("div", _hoisted_36, [
                                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "col col-auto min-width-date-time" }, [
                                    _createElementVNode("label", { class: "col-form-label" }, "Čas")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-secondary",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.minusExtraTime()))
                                    }, _cache[33] || (_cache[33] = [
                                      _createElementVNode("i", { class: "k-icon k-i-minus" }, null, -1)
                                    ]))
                                  ]),
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.extraTimeHours) + ":" + _toDisplayString(_ctx.extraTimeMinutes), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-secondary",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.plusExtraTime()))
                                    }, _cache[34] || (_cache[34] = [
                                      _createElementVNode("i", { class: "k-icon k-i-plus" }, null, -1)
                                    ]))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveSoonerTime()))
                                  }, " Odeslat ")
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (!_ctx.busCase.isKourim && !_ctx.busCase.isLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", {
                      for: "realWeight",
                      class: "col-sm-4 col-form-label"
                    }, "Naložená váha (t):", -1)),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_numerictextbox, {
                        class: "k-input-lg",
                        modelValue: _ctx.realWeight,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.realWeight) = $event)),
                        min: 0,
                        decimals: 3,
                        format: 'n3'
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _cache[41] || (_cache[41] = _createElementVNode("label", {
                      for: "deliveryNote",
                      class: "col-sm-4 col-form-label"
                    }, "Číslo dodacího listu:", -1)),
                    _createElementVNode("div", _hoisted_46, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "deliveryNote",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.deliveryNote) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.deliveryNote]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setLoaded()))
                    }, "Naloženo")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.busCase.isKourim || _ctx.busCase.isLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _cache[49] || (_cache[49] = _createElementVNode("h2", { class: "mt-4 mb-4" }, "Nahlásit nový čas dojezdu", -1)),
                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("div", { class: "col" }, [
                      _createElementVNode("label", { class: "form-label mb-3" }, "Dojezd:")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_49, [
                    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "col col-auto min-width-date-time" }, [
                      _createElementVNode("label", { class: "col-form-label" }, "Datum")
                    ], -1)),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.minusDelayDate()))
                      }, _cache[42] || (_cache[42] = [
                        _createElementVNode("i", { class: "k-icon k-i-minus" }, null, -1)
                      ]))
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.delayTimeDatePart), 1)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.plusDelayDate()))
                      }, _cache[43] || (_cache[43] = [
                        _createElementVNode("i", { class: "k-icon k-i-plus" }, null, -1)
                      ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col col-auto min-width-date-time" }, [
                      _createElementVNode("label", { class: "col-form-label" }, "Čas")
                    ], -1)),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.minusDelayTime()))
                      }, _cache[45] || (_cache[45] = [
                        _createElementVNode("i", { class: "k-icon k-i-minus" }, null, -1)
                      ]))
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.delayTimeTimePart), 1)
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.plusDelayTime()))
                      }, _cache[46] || (_cache[46] = [
                        _createElementVNode("i", { class: "k-icon k-i-plus" }, null, -1)
                      ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _cache[48] || (_cache[48] = _createElementVNode("label", {
                        class: "form-label mb-3 mt-1",
                        for: "reasonId"
                      }, "Důvod zpoždění:", -1)),
                      _withDirectives(_createElementVNode("select", {
                        id: "reasonId",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.delayReasonId) = $event)),
                        class: "form-select bg-secondary"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delayReasons, (delayReason) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: delayReason.reasonId,
                            value: delayReason.reasonId
                          }, _toDisplayString(delayReason.name), 9, _hoisted_61))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.delayReasonId]
                      ])
                    ])
                  ]),
                  _cache[51] || (_cache[51] = _createElementVNode("div", { class: "text-center" }, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary"
                    }, "Odeslat")
                  ], -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}